pageId = 'reports-questions-new'

$(document).on "pjaxload##{ pageId }", (e, $page, page) ->
  tower.initReportQuestionForm()
